import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GridActiveReports } from './GridActiveReports';
import { NavDataContext } from 'layouts/main-content/MainContent';
import { hasGridReportId } from './functions/hasReportId';
import { useSelector } from 'react-redux';
import { selectActiveReport } from 'core/slices/reports';

type GridReportsProps = {
  activeProjectKey: string;
};

export const GridReports: React.FC<GridReportsProps> = ({
  activeProjectKey,
}) => {
  const { reportId } = useParams();
  const navData = useContext(NavDataContext);
  const activeReport = useSelector(selectActiveReport);

  const [selectedReport, setSelectedReport] = useState<string | undefined>();

  useEffect(() => {
    setSelectedReport(reportId);
  }, [reportId]);

  if (
    !selectedReport ||
    !activeProjectKey ||
    !reportId ||
    !navData?.children?.length ||
    !activeReport
  ) {
    return <p>Report not found</p>;
  }

  const reportExists = hasGridReportId(navData, selectedReport);
  if (!reportExists) return <p>Report not found</p>;

  return (
    <GridActiveReports
      selectedReport={selectedReport}
      activeProjectKey={activeProjectKey}
      activeReport={activeReport}
    />
  );
};
